// extracted by mini-css-extract-plugin
export default {"error":"error___v2hn10x"};